import { createSlice } from "@reduxjs/toolkit";
import {
  getDocument,
  getDocumentDetails,
  uploadDocument,
  deleteDocument,
  getKPIDetails
} from "../services/ocr.service";

const initialState = {
  uploadLoader: false,
  deleteLoader: false,
  uploadRes: null,
  uploadSuccessMsg: "",
  deleteSuccessMsg: "",
  deleteErrorMsg: "",
  uploadErrorMsg: "",
  isUploadSuccess: false,
  documentLoader: false,
  kpiDetailsLoader: false,
  documentData: [],
  kpiDetails: [],
  totalDocumentCount: 0,
  documentDetailsLoader: false,
  documentDetailsData: [],
};
const ocrSlice = createSlice({
  name: "ocr",
  initialState: initialState,
  reducers: {
    ResetValuesUpload: (state, action) => {
      state.uploadRes = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadDocument.pending, (state, action) => {
        state.uploadLoader = true;
      })
      .addCase(uploadDocument.fulfilled, (state, action) => {
        if (action.payload) {
          state.uploadRes = action.payload.data;
          state.uploadLoader = false;
          state.uploadSuccessMsg = "Document Uploaded Successfully";
          state.isUploadSuccess = true;
        } else {
          state.uploadErrorMsg = "Document Upload Unsuccessful";
          state.uploadLoader = false;
          state.isUploadSuccess = false;
        }
      })
      .addCase(uploadDocument.rejected, (state, action) => {
        state.uploadLoader = false;
        state.uploadErrorMsg = action.error.message
          ? action.error.message
          : "Document Upload Error";
      })
      .addCase(getDocument.pending, (state, action) => {
        state.documentLoader = true;
      })
      .addCase(getDocument.fulfilled, (state, action) => {
        state.documentLoader = false;
        state.documentData = action.payload?.results;
        state.totalDocumentCount = action.payload?.count;
      })
      .addCase(getDocument.rejected, (state, action) => {
        state.documentLoader = false;
      })
      .addCase(getDocumentDetails.pending, (state, action) => {
        state.documentDetailsLoader = true;
      })
      .addCase(getDocumentDetails.fulfilled, (state, action) => {
        state.documentDetailsLoader = false;
        state.documentDetailsData = action.payload?.results;
      })
      .addCase(getDocumentDetails.rejected, (state, action) => {
        state.documentDetailsLoader = false;
      })
      .addCase(deleteDocument.pending, (state, action) => {
        state.deleteLoader = true;
      })
      .addCase(deleteDocument.fulfilled, (state, action: any) => {
        state.deleteLoader = false;
        state.deleteSuccessMsg = action.payload?.message;
      })
      .addCase(deleteDocument.rejected, (state, action: any) => {
        state.deleteLoader = false;
        state.deleteErrorMsg = action.error?.message;
      })
      .addCase(getKPIDetails.pending, (state, action) => {
        state.kpiDetailsLoader = true;
      })
      .addCase(getKPIDetails.fulfilled, (state, action) => {
        state.kpiDetailsLoader = false;
        state.kpiDetails = action.payload;
      })
      .addCase(getKPIDetails.rejected, (state, action) => {
        state.kpiDetailsLoader = false;
      });
  },
});

export const { ResetValuesUpload } = ocrSlice.actions;
export default ocrSlice.reducer;
